import { Injectable } from '@angular/core';
import { BaseBackend } from '@shared/apis/servers/base-backend';
import { Observable } from 'rxjs';
import { HttpHeaders, HttpRequest } from '@angular/common/http';
import { timeout } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class TicketBackendServer extends BaseBackend {

  getTicketFilter(builder): Observable<any> {
    return this.get(`/ticket-filter`, { params: builder });
  }

  getTickets(builder): Observable<any> {
    return this.post('/ticket/tickets', { params: builder });
  }

  exportTickets(builder): Observable<any> {
    return this.post('/ticket/export', builder);
  }

  getTicket(ticketNo): Observable<any> {
    return this.get(`/ticket/${ ticketNo }`);
  }

  saveTicketFilter(params, isNew): Observable<any> {
    if (isNew) {
      return this.post(`/ticket-filter`, params);
    } else {
      const { id } = params;
      return this.patch(`/ticket-filter/${ id }`, params);
    }
  }

  deleteTicketFilter(id): Observable<any> {
    return this.delete(`/ticket-filter/${ id }`);
  }

  syncTicket(ticketNo): Observable<any> {
    return this.get(`/ticket/${ ticketNo }/pull`);
  }

  cancelTicket(ticketNo, params): Observable<any> {
    return this.patch(`/ticket/${ ticketNo }/cancel`, params);
  }

  saveTicket(params) {
    const { ticketNo } = params;
    if (ticketNo) {
      return this.patch(`/ticket/${ ticketNo }`, params);
    }
    return this.post(`/ticket`, params);
  }

  cancelDraftTicket(params) {
    const { ticketNo } = params;
    return this.patch(`/ticket/${ ticketNo }/cancel-draft`, params);
  }

  log(ticketNo, params) {
    return this.post(`/ticket/${ ticketNo }/log`, params);
  }

  getProductView(dealerStoreId): Observable<any> {
    return this.get(`/ticket/product-view/${ dealerStoreId }`);
  }

  removeProduct(dealerStore, params): Observable<any> {
    return this.patch(`/ticket/product-view/${ dealerStore }`, params);
  }

  sendPaymentLink(params): Observable<any> {
    const { ticketNo } = params;
    return this.post(`/ticket/${ ticketNo }/payment/send-link`, params);
  }

  resendPaymentLink(ticketNo): Observable<any> {
    return this.post(`/ticket/${ ticketNo }/payment/resend-link`, null);
  }

  cancelPaymentLink(ticketNo): Observable<any> {
    return this.patch(`/ticket/${ ticketNo }/payment/cancel/send-link`, null);
  }

  creditCardPayment(params): Observable<any> {
    return this.post(`/ticket/credit-payment`, params);
  }

  updateBos(formData, ticketNo): Observable<any> {
    const headers = new HttpHeaders();
    headers.append('Content-Type', 'multipart/form-data');
    headers.append('Accept', 'application/json');

    const options = {
      headers,
      reportProgress: true,
    };

    // change post for progress bar
    const uploadReq = new HttpRequest('POST', `${ this.backend }/ticket/${ ticketNo }/updateBos`, formData, options);

    return this.http.request(uploadReq).pipe(timeout(500000));
  }

  updateAttachment(formData, ticketNo): Observable<any> {
    const headers = new HttpHeaders();
    headers.append('Content-Type', 'multipart/form-data');
    headers.append('Accept', 'application/json');

    const options = {
      headers,
      reportProgress: true,
    };

    // change post for progress bar
    const uploadReq = new HttpRequest('POST', `${ this.backend }/ticket/${ ticketNo }/updateAttachment`, formData, options);

    return this.http.request(uploadReq).pipe(timeout(500000));
  }

  deleteAttachment(params): Observable<any> {
    const { ticketNo, attachmentId } = params;
    return this.delete(`/ticket/${ ticketNo }/attachments/${ attachmentId }`, { params });
  }

  getAttachmentsList(params): Observable<any> {
    const { ticketNo } = params;
    return this.get(`/ticket/${ ticketNo }/attachmentsList`, { params });
  }

  getTicketLogs(params): Observable<any> {
    const { ticketNo } = params;
    return this.get(`/ticket/${ ticketNo }/ticket-logs`, { params });
  }

}
